import { useEffect, useState, useMemo } from "react";
import api from "@/lib/api";

export default function Scores() {
  const [scores, setScores] = useState([]);
  useEffect(() => { api.get("/scores").then((r) => setScores(r.data)); }, []);
  const stats = useMemo(() => {
    const w = scores.filter((s) => s.result === "W").length;
    const l = scores.filter((s) => s.result === "L").length;
    const t = scores.filter((s) => s.result === "T").length;
    const rs = scores.reduce((a, b) => a + (b.runs_scored || 0), 0);
    const ra = scores.reduce((a, b) => a + (b.runs_allowed || 0), 0);
    return { w, l, t, rs, ra };
  }, [scores]);
  return (
    <div data-testid="scores-page" className="py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="eyebrow mb-3">Game Results</div>
        <h1 className="font-display text-5xl sm:text-6xl uppercase font-bold tracking-tight">Scores & Standings</h1>

        <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mt-10">
          {[
            { label: "Wins", v: stats.w, color: "#00E5FF" },
            { label: "Losses", v: stats.l, color: "#FF6B6B" },
            { label: "Ties", v: stats.t, color: "#94A3B8" },
            { label: "Runs Scored", v: stats.rs, color: "#00E5FF" },
            { label: "Runs Allowed", v: stats.ra, color: "#94A3B8" },
          ].map((s) => (
            <div key={s.label} className="kr-card rounded-xl p-5 text-center">
              <div className="font-display text-4xl" style={{ color: s.color }}>{s.v}</div>
              <div className="text-xs uppercase tracking-widest text-slate-400 mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="kr-card rounded-xl mt-8 overflow-hidden">
          <table className="w-full text-sm" data-testid="scores-table">
            <thead className="bg-[#14213D] text-slate-300 uppercase text-xs tracking-widest">
              <tr>
                <th className="text-left p-4">Date</th>
                <th className="text-left p-4">Opponent</th>
                <th className="text-left p-4">Result</th>
                <th className="text-left p-4">Score</th>
                <th className="text-left p-4">Tournament</th>
              </tr>
            </thead>
            <tbody>
              {scores.length === 0 ? (
                <tr><td colSpan={5} className="p-12 text-center">
                  <div className="font-display text-3xl uppercase text-[#00E5FF]">Season Begins Soon</div>
                  <div className="text-slate-400 mt-2">Game results will appear here once the season starts.</div>
                </td></tr>
              ) : scores.map((s) => (
                <tr key={s.id} className="border-t border-white/10">
                  <td className="p-4 text-slate-400">{s.date}</td>
                  <td className="p-4 font-semibold">{s.opponent}</td>
                  <td className="p-4">
                    <span className={`font-display text-lg ${s.result === "W" ? "text-[#00E5FF]" : s.result === "L" ? "text-red-400" : "text-slate-400"}`}>{s.result}</span>
                  </td>
                  <td className="p-4">{s.runs_scored} - {s.runs_allowed}</td>
                  <td className="p-4 text-slate-400">{s.tournament || "—"} {s.placement && <span className="ml-2 text-xs text-[#00E5FF]">({s.placement})</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
